import { isCancel } from 'axios';
import queryClient from '../../constants/queryClient';

const responseMapperInterceptor = [
  function success(response) {
    if (response.config.method?.toLowerCase() !== 'get' && !response.config['LK_USE_CACHE_PROP']) {
      // eslint-disable-next-line no-console
      console.log('Инвалидируем кеши react-query');
      queryClient.invalidateQueries();
    }
    return {
      isOk: true,
      data: response.data,
    };
  },
  function error(error) {
    return {
      isOk: false,
      error,
      isCanceled: isCancel(error),
    };
  },
];

export default responseMapperInterceptor;
